// src/utils/applySiteSettings.js
import getImageUrl from "./getImageUrl";

export function applySiteSettings(data) {
  if (!data) return;

  document.title = data.site_title || "My Website";

  const faviconUrl = getImageUrl(data?.site_favicon?.path);
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;

  document.documentElement.style.setProperty(
    "--primary",
    data.back_primary_color || "#00d7ff"
  );
  document.documentElement.style.setProperty(
    "--secondary",
    data.back_secondary_color || "#1a223f"
  );
}

export function cacheSiteSettings(data) {
  if (!data) return;
  localStorage.setItem("siteSettings", JSON.stringify(data));
  localStorage.setItem("siteFavicon", getImageUrl(data?.site_favicon?.path));
  localStorage.setItem("siteLogo", getImageUrl(data?.site_logo?.path));
  localStorage.setItem("siteTitle", data.site_title);
  localStorage.setItem("primaryColor", data.back_primary_color);
  localStorage.setItem("secondaryColor", data.back_secondary_color);
}
